export function parseNonNegativePriceInput(raw: string): number | null {
  const trimmed = raw.trim();
  if (trimmed === '') {
    return null;
  }
  if (trimmed.startsWith('-')) {
    return null;
  }
  const n = Number(trimmed);
  if (!Number.isFinite(n) || n < 0) {
    return null;
  }
  return n;
}

export function nonNegativePriceInputDisplayValue(price: number | null | undefined): string {
  if (price === null || price === undefined) {
    return '';
  }
  return String(price);
}

export function shouldBlockNonNegativePriceKey(key: string): boolean {
  return key === '-' || key === 'e' || key === 'E' || key === '+';
}
